export type OrgUnitCascaderValue = [] | [number] | [number, number];

export const orgUnitFromCascadeValue = (value: OrgUnitCascaderValue): number => {
  if (typeof value === "number") {
    return value;
  }

  if (!value) {
    return 0;
  }

  if (value?.[0] && value?.[1]) {
    return value[1];
  }

  if (value?.[0]) {
    return value[0];
  }

  return 0;
};
